import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  // Initialize with actual value to prevent layout flash
  const getMatches = (q: string): boolean => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(q).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState((): boolean => getMatches(query));

  useEffect((): (() => void) => {
    const media = window.matchMedia(query);

    // Create event listener
    const listener = (e: MediaQueryListEvent): void => {
      setMatches(e.matches);
    };

    // Add the listener
    media.addEventListener('change', listener);

    // Remove listener on cleanup
    return (): void => {
      media.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
}
